export default "__VITE_ASSET__DWZzhk_1__"